import React, { useEffect, useState } from "react";
import axios from "axios";

const SlotDateSelection = ({ doctor, patient, onBack, onSelectDate }) => {
  const [slotDates, setSlotDates] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://nhniapp.in/webapi/spls/getDoctorSlotDates.php?doctorid=${doctor.doctorid}&patphno=${patient.phone}`
      )
      .then((res) => setSlotDates(res.data))
      .catch(() => alert("Failed to load slot dates"));
  }, [doctor.doctorid]);

  return (
    <div className="container">

      {/* Top Panel */}
      <div className="card mb-4 p-3 shadow-sm">
        <h5 className="text-primary mb-1">
          {doctor.title}  {doctor.doctorsname}
        </h5>
        <div className="text-muted">
          {patient.name} | {patient.phone}
          {patient.email && ` | ${patient.email}`}
        </div>
      </div>

      {/* Slot Date Table */}
      <h6 className="mb-3">Available Slot Dates</h6>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th className="text-center">Available Slot Count</th>
              <th className="text-center">Option</th>
            </tr>
          </thead>
          <tbody>
            {slotDates.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No slotDates available
                </td>
              </tr>
            ) : (
              slotDates.map((slot, index) => (
                <tr key={index}>
                  <td>{slot.slotdate}</td>
                  <td className="text-center">{slot.availcount}</td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-primary"
                      disabled={slot.availcount === 0}
                      onClick={() => onSelectDate(slot.slotdate)}
                    >
                      Select
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <button className="btn btn-secondary mt-3" onClick={onBack}>
        ← Back
      </button>
    </div>
  );
};

export default SlotDateSelection;
